import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? '0', 10) || 0;
  }

  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : '';
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
    this.ensureCartBubbleIsCorrect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageShow = (event) => {
    if (event.persisted) {
      this.ensureCartBubbleIsCorrect();
    }
  };

  onCartUpdate = async (event) => {
    const data = event.detail.data ?? {};
    const resource = event.detail.resource;
    const hasAbsoluteCartCount = resource && typeof resource.item_count === 'number';
    const itemCount = hasAbsoluteCartCount
      ? resource.item_count
      : data.source === 'product-form-component'
        ? this.currentCartCount + (Number(data.itemCount) || 0)
        : Number(data.itemCount) || 0;

    this.renderCartBubble(itemCount);
  };

  renderCartBubble = async (itemCount, animate = true) => {
    this.refs.cartBubbleCount.classList.toggle('hidden', itemCount === 0);
    this.refs.cartBubble.classList.toggle('visually-hidden', itemCount === 0);
    this.currentCartCount = itemCount;
    this.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(this.currentCartCount),
        timestamp: Date.now(),
      })
    );

    if (!animate || itemCount === 0) return;

    await new Promise((resolve) => requestAnimationFrame(resolve));
    this.refs.cartBubble.classList.add('cart-bubble--animating');
    await onAnimationEnd(this.refs.cartBubbleText);
    this.refs.cartBubble.classList.remove('cart-bubble--animating');
  };

  ensureCartBubbleIsCorrect = () => {
    if (!this.refs.cartBubbleCount) return;

    const sessionStorageCount = sessionStorage.getItem('cart-count');
    if (sessionStorageCount === null) return;

    const visibleCount = this.refs.cartBubbleCount.textContent;

    try {
      const { value, timestamp } = JSON.parse(sessionStorageCount);

      if (value === visibleCount) return;

      if (Date.now() - timestamp < 10000) {
        const count = parseInt(value, 10);
        if (count >= 0) {
          this.renderCartBubble(count, false);
        }
      }
    } catch (_) {}
  };
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
